var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZip24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.939H11.74a.5.5 0 01-.45-.28l-.95-1.89A1.49 1.49 0 009 1.939H1.5a1.5 1.5 0 00-1.5 1.5v18a1.5 1.5 0 001.5 1.5h21a1.5 1.5 0 001.5-1.5v-15a1.5 1.5 0 00-1.5-1.5zm-5 15.5a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm1.35-4.32a1.77 1.77 0 01-1.32.59h-.07a1.76 1.76 0 01-1.75-2l.38-3.85a.5.5 0 01.5-.45h1.66a.5.5 0 01.5.43l.52 3.87a1.741 1.741 0 01-.42 1.41z"
  })));
}
export default SvgIconZip24;